import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import image1 from "Assets/Images/AttendanceStreakOne.png";
import image2 from "Assets/Images/AttendanceStreakTwo.png";
import image3 from "Assets/Images/AttendanceStreakThree.png";

const AttendanceStreakDialog = ({ open, handleClose }) => {
  const [activeScreen, setActiveScreen] = useState(0);

  const streakData = {
    0: {
      label: "Update to Attendance Streaks !",
      desc: "Attendance streak counts the consecutive live classes you attended or recordings you watched within 24 hours.",
      image: image1,
    },
    1: {
      label: "Earn incentives for every streak achieved",
      desc: "Earn scaler coins and boost your attendance percentage by attending live classes and watching recordings.",
      image: image2,
    },
    2: {
      label: "Achieve your goals and milestones",
      desc: "Earn extra Scaler Coins and hit milestones just by attending your live classes and watching class recordings.",
      image: image3,
    },
  };

  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={handleClose}>
      <img src={streakData[activeScreen]?.image} alt="" />
      <DialogContent>
        <Typography fontWeight={500} variant="title">
          {streakData[activeScreen]?.label}
        </Typography>
        <Typography color="secondary.light">
          {streakData[activeScreen]?.desc}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            gap: "8px",
            "& span": {
              width: "15px",
              height: "15px",
              background: theme.palette.background.default,
              borderRadius: "50%",
            },
            "& .active": {
              background: theme.palette.primary.main,
            },
          })}
        >
          {[...Array(3)]?.map((_, i) => {
            return <span className={i == activeScreen ? `active` : ""}></span>;
          })}
        </Box>
        <Box display={"flex"} gap={"16px"}>
          {activeScreen > 0 && (
            <Button
              onClick={() => setActiveScreen((pre) => pre - 1)}
              color="secondary"
              variant="outlined"
            >
              Prev
            </Button>
          )}

          <Button
            variant="contained"
            onClick={() =>
              activeScreen >= 2
                ? handleClose()
                : setActiveScreen((pre) => pre + 1)
            }
          >
            {activeScreen >= 2 ? "Continue" : "Next"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AttendanceStreakDialog;
